package org.catharsis.spendtel.feature.presentation.settings

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import org.catharsis.spendtel.feature.legal.LegalConstants
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors
import org.catharsis.spendtel.ui.LegalLinks

@Composable
internal fun SettingsLegalFooter(
    onPrivacyClick: () -> Unit,
    onTermsClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        HorizontalDivider(
            color = SpendTelReportColors.inkMuted.copy(alpha = 0.12f),
        )

        Spacer(modifier = Modifier.height(8.dp))

        LegalLinks(
            onPrivacyClick = onPrivacyClick,
            onTermsClick = onTermsClick,
        )

        Text(
            text = "© 2026 ${LegalConstants.COMPANY_NAME} · ${LegalConstants.PRODUCT_NAME}",
            style = MaterialTheme.typography.bodySmall,
            color = SpendTelReportColors.inkMuted,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(bottom = 16.dp),
        )
    }
}
